import { Plugin } from 'rainbow-web-sdk/plugins/plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { VirtualBackgroundServiceRB } from 'rainbow-web-sdk/services/virtualBackground/virtualBackground.service';

export class VirtualBackgroundPlugin extends Plugin {
    public static initialize(): VirtualBackgroundPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[VirtualBackgroundPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[VirtualBackgroundPlugin] initialized");
            window.rainbow.plugins[VirtualBackgroundPlugin.name] = new VirtualBackgroundPlugin();
            VirtualBackgroundServiceRB.getInstance();
        }

        return window.rainbow.plugins[VirtualBackgroundPlugin.name];
    }

    private constructor() {
        super();
    }
}
